import useAdditionalGroupsByCompanySelect from 'modules/additional-groups/hooks/use-additional-groups-by-company-select';
import {AdditionalProps} from 'modules/additionals/types';
import useEditAdditionalGroupConfig from 'modules/products/hooks/use-edit-additional-group-config';
import useProductDetails from 'modules/products/hooks/use-product-details';
import {
  AdditionalGroupConfigProps,
  AdditionalGroupConfigTypeEnum,
  translatedAdditionalGroupConfigProps,
} from 'modules/products/types';
import productsKeys from 'modules/products/util/products-keys';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';
import toBrl from 'shared/util/to-brl';

const EditAdditionalGroupConfig: React.FC = () => {
  const {id, additionalGroupConfigId} = useParams();
  const productQuery = useProductDetails(id!);
  const {getSelect, getNumberInput, getSwitch, getDynamicSection} =
    useFormInputs<AdditionalGroupConfigProps>();
  const {data, isLoading} = useAdditionalGroupsByCompanySelect(
    productQuery.data?.companyId,
  );
  const [additionalGroupId, setAdditionalGroupId] = useState<string>();
  const additionals = data?.find(
    (additionalGroup) => additionalGroup.value === additionalGroupId,
  )?.data;

  const additionalInputs = useFormInputs<AdditionalProps>();

  return (
    <Edition
      border
      detailsUrl={`/products/${id}/additional-group-configs/${additionalGroupConfigId}`}
      translationKey={translatedAdditionalGroupConfigProps}
      onFormStateChange={(data) => {
        if (data.additionalGroupId !== additionalGroupId)
          setAdditionalGroupId(data.additionalGroupId);
      }}
      onSubmit={() =>
        useEditAdditionalGroupConfig(id!, additionalGroupConfigId!)
      }
      inputs={[
        getSelect({name: 'additionalGroupId', data, isLoading}),
        getSwitch({name: 'isFree'}),
        getNumberInput({name: 'min'}),
        getNumberInput({name: 'max'}),
        getSelect({
          name: 'type',
          data: [
            {label: 'Soma', value: AdditionalGroupConfigTypeEnum.sum},
            {label: 'Média', value: AdditionalGroupConfigTypeEnum.average},
            {
              label: 'Maior valor',
              value: AdditionalGroupConfigTypeEnum.highest_value,
            },
          ],
        }),
        getDynamicSection({
          name: 'additionalPricesWhenFree' as any,
          label: 'Adicionais pagos',
          inputs: [
            additionalInputs.getSelect({
              name: 'id',
              label: 'Name',
              gridColumn: 6,
              disabled: true,
              data: (additionals ?? []).map((additional) => ({
                label: additional.name,
                value: additional.id,
              })),
            }),
            additionalInputs.getPriceInput({name: 'price', gridColumn: 6}),
          ],
          translationKey: 'AdditionalProps',
          hidden: (data) => !additionals || !data.isFree,
          onCreate: {
            behavior: 'spotlight',
            title: 'Adicionais',
            spotlightOptions: additionals?.map((additional) => ({
              label: additional.name,
              value: additional,
              description: additional.price
                ? toBrl(additional.price)
                : undefined,
            })),
          },
        }),
      ]}
      queryKey={productsKeys.additionalGroupConfigDetails(
        id!,
        additionalGroupConfigId!,
      )}
    />
  );
};

export default EditAdditionalGroupConfig;
